import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 200px;

  @media (max-width: 920px) {
    padding: 0 30px;
  }
`;

export const Form = styled.div`
  background: rgba(87, 47, 111, 0.3);
  width: 615px;
  margin: 0 auto;
  font-family: 'Chemistry', sans-serif;
  text-align: center;
  padding: 30px;

  @media (max-width: 920px) {
    width: auto;
  }
`;

export const FormTitle = styled.p`
  font-size: ${({ theme }) => theme.font.middleSize};
  margin-bottom: 25px;
  text-transform: uppercase;
  letter-spacing: 15px;
`;
export const List = styled.ul`
  font-size: ${({ theme }) => theme.font.textDescrSize};
`;

export const Item = styled.li`
  margin-bottom: 20px;
`;

export const InputBox = styled.div`
  width: 80%;
  height: 70px;
  margin: 0 auto;
  background: rgba(21, 31, 40, 0.7);
`;

export const Input = styled.input`
  width: 100%;
  height: 100%;
  border: none;
  padding: 0;
  font-size: 40px;
  text-transform: uppercase;
  font-weight: 100;
  color: #cda352;
  background: transparent;
  padding-left: 40px;
  padding-right: 40px;
  box-sizing: border-box;
  text-align: center;
  outline: none;
  letter-spacing: 10px;
`;

export const Button = styled.a`
  margin-top: 30px;
  display: inline-block;
  border: none;
  background: ${({ theme }) => theme.colors.purple};
  outline: none;
  padding: 15px;
  color: ${({ theme }) => theme.colors.white};
  font-size: ${({ theme }) => theme.font.textDescrSize};
  cursor: pointer;
  transition: all 0.5s ease;
  text-transform: uppercase;
  text-decoration: none;
  pointer-events: all;

  &:hover,
  &:active {
    background: ${({ theme }) => theme.colors.purpleHover};
  }

  ${({ disabled, theme }) =>
    disabled &&
    `
    background: ${theme.colors.grey};
    pointer-events: none;
  `};
`;

export const LinkItem = styled(Link)`
  margin-top: 20px;
  font-family: 'Chemistry', sans-serif;
  font-size: 30px;
  text-decoration: none;
  color: ${({ theme }) => theme.colors.white};

  display: flex;
  align-items: center;

  span {
    display: inline-block;
    margin-right: 10px;
    font-size: 25px;
    transition: ${({ theme }) => theme.transition.button};
  }
  &:hover {
    span {
      transform: translateX(-2px);
    }
  }
`;
